<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">活动订单</div>
          <div class="orderTab">
            <div class="tab tab1" :class="{'active':status == 1}" @click="statusChange(1)">待支付</div>
            <div class="tab tab2" :class="{'active':status == 2}" @click="statusChange(2)">已支付</div>
          </div>
          <div class="listTh">
            <el-row>
              <el-col :span="11">订单详情</el-col>
              <el-col :span="4">单价</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="3">实付金额</el-col>
              <el-col :span="3">交易操作</el-col>
            </el-row>
          </div>
          <div class="orderList">
            <ul v-if="orderList.length > 0">
              <li v-for="(item,index) in orderList" :key="index" style="margin-bottom: 10px;">
                <div class="itemT">订单时间：{{item.createDate}} &nbsp;&nbsp; 订单编号：{{item.orderCode}}</div>
                <div class="itemC">
                  <el-row class="proInfo">
                    <el-col :span="11">
                      <div class="imgBox"><router-link :to="'/activitieDetails/'+item.travelId"><img :src="item.pic"></router-link></div>
                      <div class="infoBox">
                        <p class="p1">{{item.name}}</p>
                        <p class="p2">{{item.property}}</p>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="itemTd price" v-if="item.price>0 && item.num>0">成人:￥{{item.price.toFixed(2)}}</div>
                      <div class="itemTd price" v-if="item.childPrice>0 && item.childNum>0">儿童:￥{{item.childPrice.toFixed(2)}}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd num" v-if="item.price>0 && item.num>0">x{{item.num}}</div>
                      <div class="itemTd num" v-if="item.childPrice>0 && item.childNum>0">x{{item.childNum}}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd pay">￥{{item.total.toFixed(2)}}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd operation" style="padding-top: 10px;">
                        <router-link :to="'/orderDetails/'+item.id"><span>订单详情</span></router-link>
                      </div>
                      <!-- <div class="itemTd operation">
                        <span>物流信息</span>
                      </div> -->
                    </el-col>
                  </el-row>
                  <span class="opBtn cancel" v-if="item.status == 1" @click="cancelOrder(item.id)">取消订单</span>
                  <span class="opBtn pay" v-if="item.status == 1" @click="goPay(item.id)">继续支付</span>
                </div>
              </li>
            </ul>
            <div v-else style="text-align: center;padding-top: 100px;">暂无数据..</div>
          </div>
          <div style="padding:50px 0;text-align: center" v-if="orderList.length > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page="curPage"
              :page-size="10"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        userId:9,
        orderList:[],
        total:0,
        curPage:1,
        status:1
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.getOrderList()
          }
        },
        immediate: true
      }
    },
    created(){
       //this.getOrderList()
    },
    mounted(){
      eventVue.$emit("leftSwitch",'2')
    },
    methods:{
      statusChange(sta){
        this.status = sta
        this.curPage = 1
        this.getOrderList()
      },
      getOrderList(){
        this.$https.get('/api/travelOrder/getMyOrderListByPage/pageIndex/'+this.curPage+'/pageNum/10?memberId='+this.userData.id + '&status='+ this.status).then((response)=>{
          this.total = response.data.total
          this.orderList = response.data.records
        });
      },
      cancelOrder(id){
        this.$confirm('是否取消该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$https.post('/api/travelOrder/cancelTravelOrder/id/'+id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.getOrderList()
            }else{
              this.$message.warning(res.msg)
            }
          });
        }).catch(() => {});

        // this.$messagebox({
        //   title: '',
        //   message: '是否取消该订单？',
        //   showCancelButton: true
        // }).then(action => {
        //     if(action == 'confirm'){
              
        //     }
        // }).catch(err =>{
        // });
      },
      goPay(id){
        this.$router.push({
          path:`/orderDetails/${id}`
        })
      },
      handleCurrentChange(val){
        this.curPage = val
        this.getOrderList()
      }
    }
  }
</script>

<style scoped>
  .orderTab{
    overflow: hidden;
    padding: 28px 0 0 16px;
  }
  .orderTab .tab{
    float: left;
    width:130px;
    height:40px;
    line-height: 40px;
    text-align: center;
    color: #5680F9;
    cursor: pointer;
    border:1px solid rgba(86,128,249,1);
  }
  /*.orderTab .tab:hover{
    color: #ffffff;
    background:rgba(86,128,249,1);
  }*/
  .orderTab .tab.active{
    color: #ffffff;
    background:rgba(86,128,249,1);
  }
  .orderTab .tab1{
    border-radius:4px 0px 0px 4px;
     border-right: 0px;
  }
  .orderTab .tab2{
    border-radius:0px 4px 4px 0px;
     border-left: 0px;
  }
  .listTh{
    width:816px;
    text-align: center;
    height:36px;
    line-height: 36px;
    font-size: 14px;
    color: #363636;
    background: #F4F7FF;
    border:1px solid rgba(86,128,249,1);
    border-top: 3px solid rgba(86,128,249,1);
    margin: 10px 0 0 16px;
  }
  .orderList{
    width: 818px;
    padding: 10px 0 0 16px;
  }
  .orderList .itemT{
    height: 32px;
    line-height: 32px;
    padding-left: 24px;
    background: #FFFFFF;
    font-size: 12px;
    color: #666666;
    border: 1px solid #E5E5E5;
  }
  .orderList .itemC{
    padding: 12px 0px;
    background: #FBFBFB;
    min-height: 116px;
    border: 1px solid #E5E5E5;
    border-top: 0px;
    position: relative;
  }
  .orderList .itemC .opBtn{
    display: block;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    position: absolute;
    bottom: 12px;
    cursor: pointer;
  }
  .orderList .itemC .opBtn.cancel{right: 16px;}
  .orderList .itemC .opBtn.pay{right: 130px;}
  .orderList .proInfo+.proInfo{
    margin-top: 9px;
  }
  .orderList .imgBox{
    width: 118px;
    margin-left: 12px;
    float: left;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
  }
  .orderList .imgBox img{
    width: 100%;
  }
  .orderList .infoBox{
    padding: 8px 0 0 142px;
  }
  .orderList .infoBox .p1{
    height: 32px;
    overflow: hidden;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }
  .orderList .infoBox .p2{
    margin-top: 20px;
    font-size: 12px;
    color: #919191;
  }
  .orderList .itemTd{
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
  }
  .orderList .price{
    color: #919191;
    text-align: left;
    padding-left: 15px;
  }
  .orderList .num{
    color: #666666;
  }
  .orderList .pay{
    color: #E50001;
  }
  .orderList .operation{
    height: 27px;
    line-height: 27px;
  }
  .orderList .operation span{
    text-decoration: underline;
    cursor: pointer;
    color: #5680F9;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderList.vue